import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserStore } from '../../store/useUserStore';
import { fetchCurrentUser } from '../../api';
import { User } from '../../models/all';
import { isProfileComplete } from '../../utils/user';
import { logger } from '../../utils/logger';

export default function RequireProfileComplete() {
  const { user, setUser } = useUserStore();
  const [loading, setLoading] = React.useState(!user);
  const location = useLocation();

  React.useEffect(() => {
    const load = async () => {
      if (!user) {
        try {
          const u = await fetchCurrentUser();
          setUser(u as User);
        } catch (err) {
          logger.error('Failed to fetch user', err);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    load();
  }, [user, setUser]);

  if (loading) return null;

  if (!isProfileComplete(user)) {
    return <Navigate to="/profile/complete" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
